import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { DropdownOptionType, Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import mapImg from "../../../images/map-left.jpg";
import qrImg from "../../../images/facility-qr.jpg";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import toast from "react-hot-toast";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import Icon from "../../../components/icons";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { on } from "events";
import Label from "../../../components/elements/form/fromLabel";
import { PAGE_SIZE } from "../../../_common/constant";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import { AgGridReact } from "ag-grid-react";
import { titleCell } from "../../../components/elements/function";
import { useSpearPartsApi } from "../../../store/api/hooks/spearPartsApiHook";

interface Props {
  _ref: React.RefObject<HTMLDialogElement>;
  facility?: any;
  onCreate?: () => void;
  onCancel?: () => void;
  subFacility?: any;
  onContinue: (asseta: any[]) => void;
}

const CreateStocksModal: React.FC<Props> = ({
  _ref,
  facility,
  onCreate = () => {},
  onCancel = () => {},
  subFacility,
  onContinue,
}) => {
  const facilityApi: any = useFacilitiesApi();
  const [subfacilitytype, setsubfacilitytype] = useState<any>([]);
  const { showLoader, hideLoader } = useAppLoader();
  const [subfacilityimg, setSubfacityImg] = useState<any>(null);
  const {
    control,
    register,
    getValues,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<any>();
  const assetsAPI = useAssetsApi();
  const spearPartsAPI = useSpearPartsApi();
  const [searchParam, setSearchParam] = useState<any>("");
  const [rowData, setRowData] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
    const [totalRecords, setTotalRecords] = useState<number>(0);
 	const columnDefs = [
		{ headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 200, flex:1},
		{
			headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? data.value : '--'
		},
		{
			headerName: 'Bin', field: 'bin', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? data.value : '--'
		},
		{
			headerName: 'Aisle', field: 'aisle', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? data.value : '--'
		},
		{
			headerName: 'Qty on hand', field: 'qtyOnHand', headerClass: 'bg-[#f0f0f0]', flex: 1,
			cellRenderer: (data: any) => {
				const qtyOnHand = data.data?.qtyOnHand || '--';
				const unitName = data.data?.unitName || '';
				return `${qtyOnHand} ${unitName}`;
			}
		},
	];
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
    }
  };
  const getSelectedRows = () => {
    const selectedNodes = gridApi?.getSelectedNodes();
    const selectedData = selectedNodes.map((node: any) => node.data);
    setRowData(null);
    return selectedData;
  };
  const colse = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    resetForm();
    _ref?.current?.close();
    onCancel();
  };

  const getAssetsList = () => {
    showLoader();
    spearPartsAPI.locationWiseStock({
        partsID: facility.value,
        pageSize: PAGE_SIZE,
        pageNumber: 1,
        searchParam: searchParam,
      }, (data: any) => {
        hideLoader()
        setTotalRecords(data.totalRecord);
        setRowData(data.stockAdjustmentLocationWiseList ? data.stockAdjustmentLocationWiseList : []);
      }, (error: any) => {
        hideLoader()
        setRowData([]);
      });
  };

  const onSubmit = (data: any) => {
    //  console.log(data);
    let payload: any = {
      subFacilityTypeID: data.subFacilityTypeID.value,
      subFacilityName: data.subFacilityName,
      area: data.area,
      no: data.noOfRanches,
      facilityID: facility,
    };

    if (subFacility) {
      payload = {
        ...payload,
        subFacilityID: subFacility.subFacilityID,
      };
    }

    showLoader();
    facilityApi.saveSubFacility(
      payload,
      (resp: any) => {
        if (typeof data?.fileupload == "object") {
          const formData = new FormData();
          formData.append("inputFile", data.fileupload);
          formData.append("subFacilityID", resp?.returnID);
          facilityApi.SaveSubFacilityImage(
            formData,
            (resp: any) => {
              toast.success("Sub Facility Added Successfully");
              reset();
              hideLoader();
              _ref?.current?.close();
            },
            (error: any) => {
              hideLoader();
              toast.error(error);
            }
          );
        } else {
          hideLoader();
          toast.success("Sub Facility Added Successfully");
          reset();
          _ref?.current?.close();
          return;
        }
      },
      (error: any) => {
        hideLoader();
        toast.error(error);
      }
    );
  };

  const resetForm = () => {
    reset({
      subFacilityTypeID: null,
      area: null,
      noOfRanches: null,
      fileupload: "",
    });
  };

  useEffect(() => {
    if (subFacility) {
      console.log("edit sub facility with ---- ", subFacility);
      reset({
        subFacilityTypeID: subfacilitytype.find(
          (item: any) => item.value == subFacility.subFacilityTypeID
        ),
        area: subFacility.area,
        noOfRanches: subFacility.no,
        fileupload: subFacility.fullFilePath,
      });
    } else {
      resetForm();
      setRowData(null);
    }
  }, [subFacility]);



  
  useEffect(() => {
    if(isOpen && facility){
 getAssetsList();
    }
   
  }, [isOpen,facility]);



  useEffect(() => {
    if (_ref.current) {
      const modal: any = _ref.current;
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
          ) {
            setRowData([]);
            setSearchParam("");
            if (_ref.current?.hasAttribute("open")) {
                setIsOpen(true);
              
            }else{
 setIsOpen(false);
            }
          }
        }
      });
      if (modal) observer.observe(modal, { attributes: true });
      return () => observer.disconnect();
    }
  }, [_ref]);

  return (
    <dialog ref={_ref} className="modal">
      <div className="modal-box max-w-[90%] w-[70rem] p-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2">
            <p className="text-[1.063rem] text-[#755B51] font-semibold">
             Spare parts
            </p>
            <button
              onClick={colse}
              className="bg-primary text-white p-1 rounded-md"
            >
              <Icon name="close" size={1.25} />
            </button>
          </div>

          <div className="py-3">
            {facility && (
              <div className="mb-4">
                <Label text="Spare Parts" />
                <p className={`border border-[#D9D9D9] font-normal mt-3 p-4 rounded text-[16px] w-[30rem] text-[#323233]`}>{facility?.label}</p>
              </div>
            )}
            {/* {subFacility && (
              <div className="mb-4">
                <Label text="Sub Facility" />
                <p className={`border border-[#D9D9D9] font-normal mt-3 p-4 rounded text-[16px] w-[30rem] text-[#323233]`}>{subFacility?.label}</p>
              </div>
            )} */}

           

            <Button type="button" className="mt-2" onClick={getAssetsList}>
              Search
            </Button>
          </div>

          <AgGridReact
            columnDefs={columnDefs} // Pass columnDefs
            rowData={rowData} // Pass rowData
            pagination={false}
            rowSelection="multiple"
            onGridReady={onGridReady}
            domLayout="autoHeight"
            onRowClicked={onRowClicked}
          />

         
        </form>
      </div>
      <form method="dialog" className="modal-backdrop" onClick={colse}></form>
    </dialog>
  );
};

export default CreateStocksModal;
